import { ReactComponent as DeleteIcon } from '@Assets/delete.svg';
import { ReactComponent as ViewIcon } from '@Assets/view4.svg';
import { ReactComponent as DuplicateIcon } from '@Assets/duplicate.svg';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ReactComponent as SettingsIcon } from '@Assets/settings.svg';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import './BoxOptions.scss';

export default function BoxOptions(props) {
    const className = 'boxOptions';

    return (
        <div className={className}>
            {props.showCreate && (
                <Tooltip title="Create" slots={{ transition: Zoom }} arrow>
                    <AddCircleOutlineIcon
                        className={
                            className + '__create large-dashboard-icon ' +
                            (props.createDisabled ? 'grey-text is-cursor-disabled ' : 'blue-text ') +
                            (props.hovered ? 'opacity-1' : '')
                        }
                        onClick={function (e) {
                            e.stopPropagation();
                            if(!props.createDisabled) {
                                props.handleCreateClickCallback(e);
                            }
                        }}
                        disabled={props.createDisabled}
                    />
                </Tooltip>
            )}

            {props.showView && (
                <Tooltip title="View" slots={{ transition: Zoom }} arrow>
                    <ViewIcon
                        className={
                            className + '__view large-dashboard-icon ' +
                            (props.viewDisabled ? 'grey-text is-cursor-disabled ' : 'blue-text ') +
                            (props.hovered ? 'opacity-1' : '')
                        }
                        onClick={function (e) {
                            e.stopPropagation();
                            if(!props.viewDisabled) {
                                props.handleViewClickCallback(e);
                            }
                        }}
                        disabled={props.viewDisabled}
                    />
                </Tooltip>
            )}

            {props.showDuplicate && (
                <Tooltip title="Duplicate" slots={{ transition: Zoom }} arrow>
                    <DuplicateIcon
                        className={
                            className + '__duplicate large-dashboard-icon ' +
                            (props.duplicateDisabled ? 'grey-text is-cursor-disabled ' : '') +
                            (props.hovered ? 'opacity-1' : '')
                        }
                        onClick={function (e) {
                            e.stopPropagation();
                            if(!props.duplicateDisabled) {
                                props.handleDuplicateClickCallback(e);
                            }
                        }}
                        disabled={props.duplicateDisabled}
                    />
                </Tooltip>
            )}

            {props.showShiftUp && !props.shiftUpDisabled && (
                <Tooltip title="Shift Up" slots={{ transition: Zoom }} arrow>
                    <ExpandLessIcon
                        className={
                            className + '__up large-dashboard-icon ' +
                            (props.shiftUpDisabled ? 'grey-text is-cursor-disabled ' : '') +
                            (props.hovered ? 'opacity-1' : '')
                        }
                        onClick={function (e) {
                            e.stopPropagation();
                            if(!props.shiftUpDisabled) {
                                props.handleShiftUpClickCallback(e);
                            }
                        }}
                        disabled={props.shiftUpDisabled}
                    />
                </Tooltip>
            )}

            {props.showShiftDown && !props.shiftDownDisabled && (
                <Tooltip title="Shift Down" slots={{ transition: Zoom }} arrow>
                    <ExpandMoreIcon
                        className={
                            className + '__down large-dashboard-icon ' +
                            (props.shiftDownDisabled ? 'grey-text is-cursor-disabled ' : '') +
                            (props.hovered ? 'opacity-1' : '')
                        }
                        onClick={function (e) {
                            e.stopPropagation();
                            if(!props.shiftDownDisabled) {
                                props.handleShiftDownClickCallback(e);
                            }
                        }}
                        disabled={props.shiftDownDisabled}
                    />
                </Tooltip>
            )}

            {props.showSettings && (
                <Tooltip title="Settings" slots={{ transition: Zoom }} arrow>
                    <SettingsIcon
                        className={
                            className + '__settings large-dashboard-icon ' +
                            (props.settingsDisabled ? 'grey-text is-cursor-disabled ' : 'blue-text ') +
                            (props.hovered ? 'opacity-1' : '')
                        }
                        onClick={function (e) {
                            e.stopPropagation();
                            if(!props.settingsDisabled) {
                                props.handleSettingsClickCallback(e);
                            }
                        }}
                        disabled={props.settingsDisabled}
                    />
                </Tooltip>
            )}

            {props.showDelete && (
                <Tooltip title="Delete" slots={{ transition: Zoom }} arrow>
                    <DeleteIcon
                        className={
                            className + '__delete large-dashboard-icon ' +
                            (props.deleteDisabled ? 'grey-text is-cursor-disabled ' : 'red-text ') +
                            (props.hovered ? 'opacity-1' : '')
                        }
                        onClick={function (e) {
                            e.stopPropagation();
                            if(!props.deleteDisabled) {
                                props.handleDeleteClickCallback(e);
                            }
                        }}
                        disabled={props.deleteDisabled}
                    />
                </Tooltip>
            )}
        </div>
    );
}

BoxOptions.defaultProps = {
    showView: true,
    showDuplicate: false,
    showDelete: true,
    showCreate: false,
    showShiftUp: false,
    showShiftDown: false,
    showSettings: false
};
